import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryShortcuts() {
  return (
    <section className="px-4 md:px-8 lg:px-12 relative z-20">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
        {categories.map((category) => (
          <Link
            key={category.slug}
            to={`/category/${category.slug}`}
            className="group flex items-start gap-3 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-500/60 transition-all duration-300 cursor-pointer"
          >
            <span className="w-10 h-10 md:w-11 md:h-11 rounded-md bg-primary-500/12 text-primary-400 flex items-center justify-center shrink-0 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={`${category.icon} text-xl`} />
            </span>
            <span className="min-w-0">
              <span className="block text-sm md:text-[15px] font-medium text-foreground-50 group-hover:text-accent-400 transition-colors whitespace-nowrap">
                {category.name}
              </span>
              <span className="block mt-1 text-[11px] text-foreground-500 truncate">{category.highlight}</span>
            </span>
            <i className="ri-arrow-right-up-line ml-auto text-foreground-600 group-hover:text-accent-400 transition-colors shrink-0" />
          </Link>
        ))}
      </div>
    </section>
  );
}